<template>
  <div v-if="visivel" class="w3-modal" style="display: block">
    <div class="w3-container w3-modal-content w3-animate-zoom">

      <header>
        <span
          @click="fechar()"
          class="w3-button w3-display-topright">&times;</span>

        <h4 class="texto-vermelho titulo">Pesquisar Motorista</h4>
      </header>

      <exibir-processando v-if="processando"/>

      <div class="w3-col" v-if="mostrar_filtros">

        <div style="padding: 0">

          <div
            class="w3-col s2 m1 w3-dropdown-hover w3-transparent w3-center"
            style="margin-top: 22px;">

            <button class="w3-button w3-border texto-vermelho">
              <i class="fa fa-cog"></i>
            </button>

            <div
              class="w3-dropdown-content w3-bar-block w3-border"
              style="width: 0px;">

              <div
                :key="tipo_pesquisa.indice_tela"
                v-for="tipo_pesquisa in tipos_pesquisa">

                <button 
                  class="w3-bar-item w3-button botao-quadrado" 
                  @click="setChavePesquisa(tipo_pesquisa.indice_tela)">
                  
                  <i :class="getIconeFiltro(tipo_pesquisa.indice_tela)"></i>
                  <span>{{tipo_pesquisa.descricao_pesquisa}}</span>
                </button>

              </div>
            </div>
          </div>

          <div class="w3-col s10 m8 l9" style="padding-left:10px;">
            <label for="campoPesquisa">
              <span>{{tipos_pesquisa[indice_selecionado].descricao_pesquisa}}</span>
            </label>
                
            <input 
              class="w3-input w3-border w3-block"
              style="border-radius:4px" 
              v-model="chave_pesquisa"
              id="campoPesquisa"
              ref="campoPesquisa"
              autocomplete="off"
              :type="tipos_pesquisa[indice_selecionado].tipo_campo"
              :placeholder="tipos_pesquisa[indice_selecionado].placeholder"
              v-on:keyup="converterMaiusculo()"
              v-on:keyup.enter="buscar()">
          </div>

          <div class="w3-col m3 l2 w3-padding-small" style="padding:0px 0"> 
            <button 
              class="w3-col w3-button w3-theme w3-right" 
              style="margin-top: 20px;"
              v-on:click="buscar()"
              :disabled="processando">
              <span>Pesquisar</span>
            </button>                  
          </div>
        </div>
      </div>

      <div
        v-if="(
          (dados_filtrados.length > 0) &&
          (!processando) &&
          (mostrar_filtros)
        )"
        class="w3-col w3-center"
        style="margin-top: 1px;">
        
        <i
          class="fas fa-caret-down"
          @click="mostrar_filtros = false"
          style="font-size: 24px; cursor: pointer;">
        </i>
      </div>

      <div class="w3-col w3-left">
        <button 
          class="w3-bar-item w3-button w3-col w3-white w3-border w3-mobile" 
          v-if="!mostrar_filtros" v-on:click="mostrar_filtros = !mostrar_filtros">
          <i class="fa fa-filter icone-vermelho"></i>
          <span> Mostrar filtros</span>
        </button>
      </div>

      <div class="w3-col" v-if="!mostrar_filtros">
        <div class="w3-col w3-margin-top w3-margin-bottom">            
          <div 
            v-show="dados_filtrados.length > 0" 
            class="w3-responsive w3-border-top w3-border-bottom"
            v-if="!mostrar_filtros" 
            style="max-height: calc(75vh - 300px); min-height: 200px; overflow: auto">
            
            <div
              class="w3-show card-item w3-border w3-container"
              :key="motorista.motorista_id"
              v-for="motorista in dados_filtrados"
              @click="confirmar(motorista)">

              <div class="w3-col s12">
                <label>Nome: </label>
                <strong class="w3-text-theme">{{motorista.motorista_id + '-' + motorista.nome_razao_social}}</strong>
              </div>             

              <div class="w3-col s12" v-if="motorista.cpf">
                <label>CPF: </label>
                <label>{{motorista.cpf}}</label>
              </div> 

              <div class="w3-col s12" v-if="motorista.cnpj">
                <label>CNPJ: </label>
                <label>{{motorista.cnpj}}</label>
              </div> 

              <div class="w3-col s12" v-if="motorista.nome_empresa_transporte">
                <label>Empresa transporte: </label>
                <label>{{motorista.empresa_transporte_id + '-' + motorista.nome_empresa_transporte}}</label>
              </div>
            </div>
          </div>
        </div>

        <footer class="w3-container w3-col conteudo-centralizado"></footer>
      </div>
    </div>
  </div>
</template>

<script>
  import RMotorista from '@/components/Rest/RMotorista.js'
  import ExibirProcessando from '@/components/ExibirProcessando'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'

  export default {
    name: 'PesquisaMotorista',
    
    components: {
      ExibirProcessando
    },

    data() {
      return {
        visivel: false,

        tipos_pesquisa: [
          {
            indice_tela: 0,
            tipo: 'COD',
            tipo_campo: 'number',
            descricao_pesquisa: 'Código',
            placeholder: 'Digite o código'
          },

          {
            indice_tela: 1,
            tipo: 'NRS',
            tipo_campo: 'text',
            descricao_pesquisa: 'Razão social',
            placeholder: 'Digite a razão social'
          },

          {
            indice_tela: 2,
            tipo: 'NRF',
            tipo_campo: 'text',
            descricao_pesquisa: 'Nome fantasia',
            placeholder: 'Digite o nome fantasia'
          },

          {
            indice_tela: 3,
            tipo: 'CPF',
            tipo_campo: 'number',
            descricao_pesquisa: 'CPF/CNPJ (Somente números)',
            placeholder: 'Digite o CPF/CNPJ'
          },

          {
            indice_tela: 4,
            tipo: 'TEL',
            tipo_campo: 'number',
            descricao_pesquisa: 'Telefone (somente números)',
            placeholder: 'Digite o telefone'
          }
        ],
  
        indice_selecionado: 1,
        mostrar_filtros: true,
        dados_filtrados: [],
        chave_pesquisa: '',
        processando: false
      };
    },
    methods: {
      abrir() {
        this.visivel = true;
        this.indice_selecionado = 1;
        this.mostrar_filtros = true;
        this.dados_filtrados = [];
        this.chave_pesquisa = '';
        this.$nextTick(() => this.$refs.campoPesquisa.focus());
      },

      fechar() {
        this.visivel = false;
      },

      setChavePesquisa(indice) {
        this.chave_pesquisa = '';
        this.indice_selecionado = indice;
        this.$nextTick(() => this.$refs.campoPesquisa.focus());
      },

      getIconeFiltro(indice) {
        if(indice == this.indice_selecionado) {
          return 'fa fa-check-square icone-vermelho';
        }
        else {
          return 'far fa-square';
        }
      },

      converterMaiusculo() {
        this.chave_pesquisa = this.chave_pesquisa.toUpperCase();
      },

      async buscar() {
        try {
          this.processando = true;
          this.dados_filtrados = [];

          let parametros = {
            tipo: this.tipos_pesquisa[this.indice_selecionado].tipo,
            chave: this.chave_pesquisa
          }

          let retorno = await RMotorista.buscarMotorista(this.axios, parametros);
          if (retorno.houve_erro == 'S') {
            throw new Error(retorno.mensagem);
          }

          this.dados_filtrados = JSON.parse(JSON.stringify(retorno.dados));
          this.mostrar_filtros = false;
          this.processando = false;
        }
        catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
          return;
        }
      },

      confirmar(registro_selecinado) {
        this.fechar();
        this.$emit('confirmar', registro_selecinado);
      }
    }
  };
</script>

<style escoped>
  @media screen and (min-width: 1200px) {
    .w3-modal-content {
      width: 80%;
    }
  }

  @media screen and (max-width: 1199px) {
    .w3-modal-content {
      width: 95%;
    }
  }

  .fundo-enfase {
    background-color: #dedede;
  }

  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    cursor: pointer;
  }

</style>





// WEBPACK FOOTER //
// src/components/Pesquisas/pesquisaMotoristas.vue